export class ModeloBase {
  dth_insercao?: Date;

  num_total?:number;

}
